'use strict';
import DataTable from '../../../node_modules/datatables.net-dt/js/dataTables.dataTables.js';
import '../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css';
import '../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.css';
import '../../../node_modules/datatables.net-buttons-dt/js/buttons.dataTables.js';
import '../../../node_modules/datatables.net-buttons/js/buttons.colVis.js';
import '../../../node_modules/datatables.net-buttons/js/buttons.html5.js';
import '../../../node_modules/datatables.net-buttons/js/buttons.print.js';
import '../../../node_modules/datatables.net-responsive/js/dataTables.responsive.js';
import '../../../node_modules/datatables.net-responsive-dt/js/responsive.dataTables.js';
import '../../../node_modules/datatables.net-fixedcolumns/js/dataTables.fixedColumns.js';

import CSVGenerator from "../generators/CSVGenerator.js";
import XLSXGenerator from "../generators/XLSXGenerator.js";
import {DatatableHelper} from "../helpers/DatatableHelper.js";
import {Helper} from "../helpers/Helper.js";

export class Datatables {
	#dataTables;
	_choices = [];
	#datatableChanged;
	#datatables_per_page;
	#admin_ajax;
	_levDatatables = {};

	constructor() {
		if (typeof datatable_vars != 'undefined') {
			this.#datatables_per_page = datatable_vars.datatable_per_page;
		}
		if (typeof admin_ajax != 'undefined') {
			this.#admin_ajax = admin_ajax[0];
		}
		this._setCookie('dateFilterStart', '', 1);
		this._setCookie('dateFilterEnd', '', 1);
		this.#dataTables = document.querySelectorAll( '.dataTable' );
		this._addLoadingClass();
		this.#initAllTables();
		this._datatableActions();
		this.addExistingFilters()
	}

	_setCookie(name, value, days) {
		let expires = "";
		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	_addLoadingClass() {
		DataTable.defaults.fnInitComplete = ( dTable ) => {
			dTable.nTableWrapper.classList.add( 'loaded' );
		};

		DataTable.ext.search.push( function ( settings, data, dataIndex ) {
			const dateFilterKey = settings.oInit.dateFilterKey;
			if ( ! dateFilterKey ) return true;

			if ( isNaN(dateFilterKey) ) {
				const minElementHeading = document.querySelector(
					`[data-key="${dateFilterKey}"][data-subtype="start"]`
				);
				const maxElementHeading = document.querySelector(
					`[data-key="${dateFilterKey}"][data-subtype="end"]`
				);

				const minElement = document.querySelector(
					`#date-min-${minElementHeading.dataset.index}`
				);
				const maxElement = document.querySelector(
					`#date-max-${maxElementHeading.dataset.index}`
				);

				const start_date = Date.parse(data[minElementHeading.dataset.index]);
				const end_date = Date.parse(data[maxElementHeading.dataset.index]);
				const min = Date.parse(minElement.value);
				const max = Date.parse(maxElement.value);

				if (
					(isNaN(min) && isNaN(max)) ||
					(isNaN(min) && end_date <= max) ||
					(min <= start_date && isNaN(max)) ||
					(min <= start_date && end_date <= max)
				) {
					return true;
				}

			} else {
				const minElement = document.getElementById(
					`date-min-${dateFilterKey}`
				);
				const maxElement = document.getElementById(
					`date-max-${dateFilterKey}`
				);

				if (!maxElement || !minElement) return true;

				const date = Date.parse(data[dateFilterKey]);
				const min = Date.parse(minElement.value);
				const max = Date.parse(maxElement.value);

				if (
					(isNaN(min) && isNaN(max)) ||
					(isNaN(min) && date <= max) ||
					(min <= date && isNaN(max)) ||
					(min <= date && date <= max)
				) {
					return true;
				}
			}
			return false;
		} );
	}

	_attrToArray( columnNumbers ) {
		if ( columnNumbers ) {
			const columnsArray = columnNumbers.split( ',' );
			return columnsArray.map( ( item ) => parseInt( item ) );
		}
		return [];
	}

	_getTableOptions(table) {
		const headingsTags = table.querySelectorAll('thead tr th,thead tr td');
		const columnDefs = [];
		const columns = [];
		const searchableColumns = this._attrToArray(
			table.dataset.searchable
		);
		const hiddenColumns = this._attrToArray(
			table.dataset.hiddencolumns
		);
		let colWidths = table.dataset.colwidths;
		const childToggle = +table?.dataset?.childToggle;
		const childToggleVisibility = table?.dataset?.childToggleVisibility !== 'false';

		let emptyColumns = [];

		if (childToggle >= 0 && childToggleVisibility) {
			emptyColumns.push(childToggle);
		}

		headingsTags.forEach((el,index) => {
			if (index === childToggle){
				if (childToggleVisibility) {
					columns.push({
						className: 'levcharity-datatables-details-control',
						orderable: false,
						data: null,
						type: 'html',
						defaultContent: '<span class="details-controll-icon-wrapper"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 16.6622L20.6 12L22 13.4189L16 19.5L10 13.4189L11.4 12L16 16.6622Z" fill="#828282"/></svg></span>',
					});
				} else {
					let leaveCount = emptyColumns.filter(el => index > el).reduce((partialSum, a) => partialSum + a + 1, 0);
					columns.push({
						data: index - leaveCount,
						type: 'html',
						className: 'levcharity-datatables-details-control custom',
					})
				}
			} else {
				let leaveCount = emptyColumns.filter(el => index > el).reduce((partialSum, a) => partialSum + a + 1, 0);
				columns.push({
					data: index - leaveCount,
					type: el.dataset.colType ? el.dataset.colType : (el.children.length ? 'html' : 'string')
				})
			}
		})

		const noSorting = this._attrToArray( table.dataset.nosorting );
		if ( noSorting && noSorting.length ) {
			columnDefs.push( { orderable: false, targets: noSorting } );
		}

		if ( searchableColumns && searchableColumns.length ) {
			columnDefs.push( {
				searchable: true,
				targets: searchableColumns,
			} );
		}

		if(hiddenColumns && hiddenColumns.length){
			columnDefs.push(
				{ targets: hiddenColumns, visible: false }
			);
		}

		if(colWidths && colWidths.length) {
			const sizeUnitsRegex = /(?:px|%|vw|dvw|vh|dvh|em|rem|cm|mm|in|pt|pc|ex|ch|vmin|vmax|cap|ic|lh|rlh|vi|vb|avi|avb|adp|ads|adc|gs|gw|gh|gr|vwport|wh|slm|mozc|q|lq|dppx|dpcm|dpi|ms|s|Hz|kHz|deg|rad|grad|turn|dpi|dpcm|dppx|fr|c|rem)$/i;
			colWidths = JSON.parse(colWidths);

			colWidths.map(colWidth => {
				let targets = [];
				if (Array.isArray(colWidth.targets)) {
					targets = colWidth.targets;
				} else {
					targets = [colWidth.targets];
				}

				colWidth.targets = targets;

				targets.forEach(targetIndex => {
					let width = colWidth.width;

					if (!sizeUnitsRegex.test(width)) {
						width += 'px';
					}

					colWidth.width = width;
				})

				return colWidth;
			})
		}

		const action = table.dataset.action ?? false,
			reporting = table?.dataset?.reporting === 'true',
			per_page = table.dataset.perpage ? parseInt(table.dataset.perpage) : (this.#datatables_per_page ? this.#datatables_per_page : 10),
			id = table.dataset.id ?? false,
			email = table.dataset.email ?? false,
			type = table.dataset.type ?? false,
			queryParams = JSON.parse(table.dataset.query ?? '{}'),
			currency = table.dataset.currencyfiltering ?? false,
			serverSide = table.dataset.serverside ?? false,
			processing = table.dataset.processing ?? true,
			time = new Date().getTime(),
			deferRender = table.dataset.deferrender ?? false,
			csv_export_columns = table?.dataset?.exportColumns || '',
			hide_csv_button = table?.dataset?.hideCsvButton === 'true',
			hide_search = table?.dataset?.hideSearch === 'true',
			sendUserTimezone = table?.dataset?.userTimezone === 'true',
			csv_button_text = reporting ? '+ ' + wp.i18n.__('CSV', 'levcharity') : wp.i18n.__('CSV', 'levcharity'),
			excel_button_text = reporting ? '+ ' + wp.i18n.__('Excel', 'levcharity') : wp.i18n.__('Excel', 'levcharity'),
			csv_export = table?.dataset?.csvExport || 'default',
			dom =
				`<"lev-datatable--actions"
					<"${ table.id }--filters">
					<"lev-datatable-search-buttons"fB>
				>
				<"levcharity_datatable_wrapper is-bordered-wrapper"t"
					<"lev-datatable--pagination-wrapper"lip>
				>`,
			tableOptions = {
				processing,
				serverSide,
				searching: !hide_search,
				dom: dom,
				buttons: [],
				filter: true,
				pagingType: 'simple_numbers',
				language: {
					lengthMenu: `${wp.i18n.__('Show:', 'levcharity')} _MENU_`,
					searchPlaceholder: wp.i18n.__('Search', 'levcharity'),
					info: `_PAGE_ ${wp.i18n.__('of', 'levcharity')} _PAGES_ (${/* translators: %s: total number of entries */ wp.i18n.sprintf(wp.i18n._n('%s entry', '%s entries', `_TOTAL_`, 'levcharity'), `_TOTAL_`)})`,
					zeroRecords: wp.i18n.__('No matching records found', 'levcharity'),
					infoEmpty: "",
					infoFiltered: "",
					paginate: {
						next: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_332_5260)"><path d="M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z" /> </g><defs><clipPath id="clip0_332_5260"><rect width="24" height="24"/></clipPath></defs></svg>',
						previous: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_332_5258)"><path d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z" /></g><defs><clipPath id="clip0_332_5258"><rect width="24" height="24"/></clipPath></defs></svg>',
					},
					processing: `<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`,
					loadingRecords: '',
				},
				oLanguage: {
					sSearch: '',
				},
				columnDefs,
				columns,
				colWidths,
				scrollX: false
			};

		if (!hide_csv_button && !serverSide) {
			const exportOptions = {};

			let customize = csv => {

				const datatable = this._levDatatables[table.id];
				let data = datatable.rows().data().toArray();

				let actionsIndex = -1;

				data = data.map((row) => {

					if (typeof row.child_row !== 'undefined') {
						row[1] = {
							value: row[1],
							subitems: row.child_row
						}

						delete row.child_row;
					}

					if (!Array.isArray(row)){
						row = Object.values(row);
					}

					row = row.filter((d, i) => {
						if (d?.value){
							d = d.value
						}
						const match = /class=".*select_actions_wrapper.*"/.test(d)

						if (match){
							actionsIndex = i;
						}

						return !match;
					}).map(d => {
						if (d?.value) {
							d.value = d.value.replace(/<[^>]*>/g, '')
						} else {
							d = (d + '').replace(/<[^>]*>/g, '')
						}
						return d;
					})

					return row;
				})

				const offset = (childToggle >= 0) + 0;

				if (typeof csv.split !== 'function') {
					var sheet = csv.xl.worksheets['sheet1.xml'];

					const export_cols = this._attrToArray(csv_export_columns);
					let headings = [...headingsTags]
						.map((el, index) =>
							`<c t="inlineStr" s="2">
								<is>
									<t xml:space="preserve">${el.textContent}</t>
								</is>
							</c>`);
					if (csv_export_columns){
						headings = export_cols.map(index => headings[index]).join('');
					}
					headings = headings.filter((h, i) => i !== actionsIndex);

					sheet.querySelector('row[r="2"]').innerHTML = headings

					sheet.querySelectorAll('row:not([r="1"]):not([r="2"])').forEach(r => r.remove())

					const xlsxGenerator = new XLSXGenerator('');

					const xlsx = xlsxGenerator.generate(data, false, offset);

					sheet.querySelector('sheetData').innerHTML += xlsx;

					sheet.querySelectorAll('row:not([r="1"]):not([r="2"])').forEach((el, ind) => {
						const row = ind + 3;
						el.setAttribute('r', row)
						el.querySelectorAll('c').forEach((cell, cind) => {
							cell.setAttribute('r', xlsxGenerator.numberToChar(cind + 1) + row)
						})
					})
				} else {
					let newCsv = csv.split('\n')
					let headings = newCsv[0]
					const export_cols = this._attrToArray(csv_export_columns);
					headings = [...headingsTags]
						.map(el => `"${el.textContent}"`)
					if (csv_export_columns){
						headings = export_cols.map(index => headings[index]).join(',');
					}
					headings = headings.filter((h, i) => i !== actionsIndex);

					csv = newCsv.join("\n");
					newCsv[0] = headings;

					const csvGenerator = new CSVGenerator('');
					csv = headings + csvGenerator.generate(data, false, offset);
				}

				return csv;
			};

			if (csv_export_columns) {
				exportOptions.columns = this._attrToArray(csv_export_columns);
			}

			const csvButton = {
				extend: 'csvHtml5',
				text: csv_button_text,
				className: 'levcharity_button medium download_button small',
				exportOptions,
				customize,
			};
			const excelButton = {
				extend: 'excelHtml5',
				text: excel_button_text,
				className: 'levcharity_button medium download_button small',
				exportOptions,
				customize,
			};

			tableOptions.buttons.push(csvButton,excelButton);
		}

		if(serverSide && !hide_csv_button ) {
			tableOptions.buttons.push(
				{
					extend: 'excelHtml5',
					text: 'Export to Excel',
					action:  (e, dt, button, config) => {
						let table_id = table.getAttribute('id');
						if(table_id) {
							let filters = document.querySelectorAll(`[data-for="${table_id}"]`);
							let params =  dt.ajax.params();
							const data = {
								action: `download_xlsx_${action}`,
								columns: params.columns
							};

							Array.from(filters).forEach((filter)=>{
								let filter_name = filter.getAttribute('name');
								let filter_value = filter.value;
								data[filter_name] = filter_value;
							});

							fetch(this.#admin_ajax, {
								method: 'POST',
								body: Helper.objectToFormData(data),
							})
								.then((response) => {
									if (response.ok) {
										return response;
									} else {
										throw new Error('Network response was not ok');
									}
								})
								.then((response) => {
									let disposition = response.headers.get('Content-Disposition');
									let filename = 'report.xlsx';
									if (disposition && disposition.indexOf('attachment') !== -1) {
										let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
										let matches = filenameRegex.exec(disposition);
										if (matches != null && matches[1]) {
											filename = matches[1].replace(/['"]/g, '');
										}
									}
									return response.blob().then(blob => {
										let url = window.URL.createObjectURL(blob);
										let a = document.createElement('a');
										a.href = url;
										a.download = filename;
										document.body.appendChild(a);
										a.click();
										window.URL.revokeObjectURL(url);
									});
								})
								.catch((error) => {
									console.error('Fetch error:', error);
								});
						}
					},
					className: 'levcharity_button medium download_button',
				},
				{
					extend: 'csvHtml5',
					text: 'Export to CSV',
					action: (e, dt, button, config) => {
						let table_id = table.getAttribute('id');
						if (table_id) {
							let filters = document.querySelectorAll(`[data-for="${table_id}"]`);
							let params = dt.ajax.params();
							const data = {
								action: `download_csv_${action}`,
								columns: params.columns
							};
							Array.from(filters).forEach((filter) => {
								let filter_name = filter.getAttribute('name');
								let filter_value = filter.value;
								data[filter_name] = filter_value;
							});


							fetch(this.#admin_ajax, {
								method: 'POST',
								body: Helper.objectToFormData(data),
							})
								.then((response) => {
									if (response.ok) {
										return response;
									} else {
										throw new Error('Network response was not ok');
									}
								})
								.then((response) => {
									let disposition = response.headers.get('Content-Disposition');
									let filename = 'report.csv';
									if (disposition && disposition.indexOf('attachment') !== -1) {
										let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
										let matches = filenameRegex.exec(disposition);
										if (matches != null && matches[1]) {
											filename = matches[1].replace(/['"]/g, '');
										}
									}
									return response.blob().then(blob => {
										let url = window.URL.createObjectURL(blob);
										let a = document.createElement('a');
										a.href = url;
										a.download = filename;
										document.body.appendChild(a);
										a.click();
										window.URL.revokeObjectURL(url);
									});
								})
								.catch((error) => {
									console.error('Fetch error:', error);
								});
						}
					},
					className: 'levcharity_button medium download_button',
				},
			);
		}

		if ( action ) {
			tableOptions.ajax = {
				url: this.#admin_ajax ? this.#admin_ajax : 'admin-ajax.php',
				data: { action, id, email, type, time },
			};

			if(currency) {
				tableOptions.ajax.data.currency = currency;
			}

			if(queryParams) {
				tableOptions.ajax.data = Object.assign({}, tableOptions.ajax.data, queryParams);
			}

			if (sendUserTimezone){
				tableOptions.ajax.data.timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || '';
			}
		}
		if(per_page){
			tableOptions.pageLength = per_page;
		}
		if(deferRender){
			tableOptions.deferRender = true;
		}

		return tableOptions;
	}

	async _addDaterangeFilter(table, filtersWrapper, levDatatable) {
		const daterangefilter = table.dataset.daterangefilter;
		const that = this;
		// Dynamically import the Lightpick library
		const { default: Lightpick } = await import('lightpick') /* webpackChunkName: "lightpick" */;
		if (daterangefilter) {
			filtersWrapper.innerHTML += `
						<div class="dt-filter-wrapper filter-type-dropdown" id="order-date-filter-wrapper">
							<div class="dt-filter-wrapper orderFilterWrapper">
								<input type="text" autocomplete="off" id="order-date-filter" class="date-picker" placeholder="Dates" />
							</div>
						</div>`;
		}

		if (document.getElementById('order-date-filter')) {
			setTimeout(() => {
				new Lightpick({
					field: document.getElementById('order-date-filter'),
					singleDate: false,
					selectForward: true,
					onSelect: function (start, end) {
						let dateFilterStart = start ? start.format('YYYY-MM-DD') : '',
							dateFilterEnd = end ? end.format('YYYY-MM-DD') : '';

						if (start && end && start <= end) {
							that._setCookie('dateFilterStart', dateFilterStart, 1);
							that._setCookie('dateFilterEnd', dateFilterEnd, 1);
							that.#datatableChanged = true;
							document.querySelector('.dt-processing').style.display = 'block';
							levDatatable.ajax.reload();
						}
					}
				});
			}, 500);
		}
	}

	_hasFilters(tableHeadings) {
		let hasFilters = false;
		tableHeadings.forEach( ( th, index ) => {
			if ( th.dataset.filter === '1' ) {
				hasFilters = true;
			}
		} );

		if (!hasFilters) {
			hasFilters = !!document.querySelector('.lev-datatable--actions');
		}

		return hasFilters;
	}

	#initAllTables() {
		this.#dataTables?.forEach( ( table ) => {

			const tableHeadings = table.querySelectorAll( 'thead th' );

			const tableOptions = this._getTableOptions(table);

			const classObject = this;

			if ( this._hasFilters(tableHeadings) ) {

				const filtersWrapper = document.createElement( 'div' );
				filtersWrapper.className = 'filters-wrapper';

				tableOptions.drawCallback = function () {
					if(!classObject.#datatableChanged) {
						return;
					}

					classObject._updateDropdownFilters(this, tableHeadings);
					setTimeout(() => {
						classObject._updateChoices();
					}, 500);
					classObject.#datatableChanged = false;
				};

				tableOptions.initComplete = function () {

					classObject._addDaterangeFilter(table, filtersWrapper, levDatatable);

					classObject.addExistingFilters(table, levDatatable);

					classObject._addFilters(this, tableHeadings, filtersWrapper, levDatatable, tableOptions);

					setTimeout(() => {
						document.querySelector(`.${ table.id }--filters`).innerHTML = filtersWrapper.outerHTML;
					}, 100)

					setTimeout(() => {
						classObject.initChoices();
					}, 500);
					classObject?._addEvents(levDatatable);
				};
			}


			let isRendered = false;
			const tableId = table.id;
			const levDatatable = new DataTable( `#${ tableId }`, tableOptions );
			this._levDatatables[tableId] = levDatatable;
			levDatatable.on('draw.dt', function() {

				setTimeout(() => {
					levDatatable.containers()[0]?.querySelectorAll('colgroup')?.forEach(row => {
						const cols = row.querySelectorAll('col');

						tableOptions.colWidths?.forEach(col => {
							col.targets.forEach(index => {
								cols[index].style.width = col.width;
								cols[index].style.setProperty('--column-width', col.width);
							})
						});
					})

					classObject._updateExistingFilters(table, tableOptions, tableHeadings);
				}, 10)

				if(!isRendered){
					setTimeout(()=>{
						let filterElement = document.querySelector( `#${tableId} [data-defaultfilter]`);
						if( filterElement ) {
							let filterValue = filterElement.getAttribute("data-defaultfilter");
							levDatatable.column(7).search(`^(?!.*${filterValue}).*$`, true, false).draw();
							isRendered = true;
						}
					}, 100);
				}
			});

			levDatatable.on('click', 'td.levcharity-datatables-details-control', (e) => {
				let tr = e.target.closest('tr');
				let row = levDatatable.row(tr);

				if (row.child.isShown()) {
					row.child.hide();
				}
				else {
					row.child(this.#renderChildRow(row.data())).show();
				}
			})
		} );
	}

	_updateDropdownFilters(that, tableHeadings) {
		const filterableColumns = {},
			filterableColumnNames = {},
			filterableColumnsContent ={},
			filterableColumnsDefault ={},
			filterableIndexes = [];
		tableHeadings.forEach( ( th, index ) => {
			if ( th.dataset.filter === '1' ) {
				filterableIndexes.push( index );
				filterableColumns[ index ] = th.dataset.type ?? 'basic';
				filterableColumnsContent[ index ] = th.dataset.content ?? '';
				filterableColumnsDefault[ index ] = th.dataset.defaultfilter ?? '';
				if ( th.dataset.filtername ) {
					filterableColumnNames[ index ] = th.dataset.filtername;
				}
			}
		} );
		const filterTextTesting = document.createElement( 'div' );
		filterTextTesting.id = 'filterTextTesting';
		filterableIndexes.forEach( ( colIndex ) => {
			let filterField,
				filterName = tableHeadings[ colIndex ].innerText;

			if (
				tableHeadings[ colIndex ].dataset.subtype &&
				(
					tableHeadings[ colIndex ].dataset.subtype === 'start' ||
					tableHeadings[ colIndex ].dataset.subtype === 'end'
				)
			) {
				filterName = wp.i18n.__('date', 'levcharity');
			}

			if (
				filterableColumnNames[ colIndex ] &&
				filterableColumnNames[ colIndex ] !== ''
			) {
				filterName = filterableColumnNames[ colIndex ];
			}


			if ( filterableColumns[ colIndex ] === 'dropdown' || filterableColumns[ colIndex ] === 'split-dropdown' ) {
				const isSplit = filterableColumns[ colIndex ] === 'split-dropdown'

				filterField = '';
				let columnData = that
						.api()
						.column( colIndex )
						.data(),
					filteredColumnData = [];
				for ( let i = 0; i < columnData.length; i++ ) {
					let val = columnData[ i ];
					if ( val && val.indexOf( '<' ) === 0 ) {
						filterTextTesting.innerHTML = val;
						val = filterTextTesting.innerText;
					}
					if (
						! ( filteredColumnData.indexOf( val ) >= 0 )
					) {
						filteredColumnData.push( val );
					}
				}
				filteredColumnData = filteredColumnData.sort(
					function ( a, b ) {
						return new Date( b ) - new Date( a );
					}
				);

				filterField += `<option value="">${filterName}</option>`;

				let optionsArray = []

				filteredColumnData.forEach( ( val ) => {
					if (isSplit) {
						val.split(', ').forEach(v => {
							optionsArray.push(v);
						})
					} else {
						optionsArray.push(val);
					}
				} );

				optionsArray = optionsArray.filter((value, index, array) => value !== '' && array.indexOf(value) === index)

				optionsArray.forEach( ( val ) => {
					filterField += `<option value="${ val }">${ val }</option>`;
				} );

				const existingFilter = document.getElementById(`${ filterName }-${ colIndex }`);
				if(existingFilter) {
					existingFilter.innerHTML = filterField;
				}
			}
		} );
	}

	async _updateExistingFilters(table, tableOptions, tableHeadings) {
		const table_id = table.id;
		const action = table.dataset.action;

		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */)

		let existingFiltersElements = document.querySelectorAll(`[data-for="${table_id}"]`);

		if(existingFiltersElements.length){
			const filters = [];
			const selectedFilters = {};
			existingFiltersElements.forEach((element)=>{
				let elementTagName = element.tagName.toLowerCase();
				if(elementTagName === 'select') {
					filters.push(element.name);
				}

				selectedFilters[element.name] = element.value;
			});

			await Helper.request(this.#admin_ajax, {
				action: 'update_datatable_filters_' + action,
				filters,
				...selectedFilters
			}, {
				method: 'get'
			})
			.then(response => {
				if (response.values) {
					const values = response.values;

					existingFiltersElements.forEach((element)=>{
						let elementTagName = element.tagName.toLowerCase();
						if(elementTagName === 'select') {
							if (typeof values[element.name] !== 'undefined') {
								const placeholder = [...element.options].find(o => o.value === '');

								let newContent = ''

								if (placeholder) {
									newContent += placeholder.outerHTML;
								}

								for (const key in values[element.name]) {
									const val = values[element.name][key];
									newContent += `<option value="${key}">${val}</option>`;
								}

								element.innerHTML = newContent;
								element.value = selectedFilters[element.name];
							}
						}
					});
				}
			})
		}
	}

	async _addFilters(that, tableHeadings, filtersWrapper, levDatatable, tableOptions) {
		const { default: Lightpick } = await import('lightpick') /* webpackChunkName: "lightpick" */;
		const filterableColumns = {},
			filterableColumnNames = {},
			filterableColumnsContent ={},
			filterableColumnsDefault ={},
			filterableIndexes = [];
		tableHeadings.forEach( ( th, index ) => {
			if ( th.dataset.filter === '1' ) {
				filterableIndexes.push( index );
				filterableColumns[ index ] = th.dataset.type ?? 'basic';
				filterableColumnsContent[ index ] = th.dataset.content ?? '';
				filterableColumnsDefault[ index ] = th.dataset.defaultfilter ?? '';
				if ( th.dataset.filtername ) {
					filterableColumnNames[ index ] = th.dataset.filtername;
				}
			}
		} );
		const filterTextTesting = document.createElement( 'div' );
		filterTextTesting.id = 'filterTextTesting';

		filterableIndexes.forEach( ( colIndex ) => {
			let filterField, rangepickerElement = '',
				filterName = tableHeadings[ colIndex ].innerText;

			if (
				tableHeadings[ colIndex ].dataset.subtype &&
				(
					tableHeadings[ colIndex ].dataset.subtype === 'start' ||
					tableHeadings[ colIndex ].dataset.subtype === 'end'
				)
			) {
				filterName = wp.i18n.__('date', 'levcharity');
			}

			if (
				filterableColumnNames[ colIndex ] &&
				filterableColumnNames[ colIndex ] !== ''
			) {
				filterName = filterableColumnNames[ colIndex ];
			}

			let appendTheFilter = true;

			if ( filterableColumns[ colIndex ] === 'dropdown' || filterableColumns[ colIndex ] === 'split-dropdown' ) {
				const isSplit = filterableColumns[ colIndex ] === 'split-dropdown'

				let filterDefault = filterableColumnsDefault[colIndex] ?? '';
				let filterClasses = tableHeadings[ colIndex ].dataset.classes;
				let filterAttributes = filterClasses && filterClasses.includes('multi_choices') ? 'multiple="multiple"' : '';
				if (isSplit) {
					filterAttributes += ' data-split-dropdown="true"'
				}
				filterField = `<div class="dt-filter-wrapper"><label for="${ filterName }-${ colIndex }"></label><select ${filterAttributes} id="${ filterName }-${ colIndex }" ${ filterDefault ? 'data-filterDefault='+filterDefault : ''} ${filterableColumnsContent[colIndex] == "html" ? 'data-content="html"' : ''} class='dt-filter levcharity_select ${filterClasses || ''}' data-key="${ colIndex }">`;
				let columnData = that
						.api()
						.column( colIndex )
						.data(),
					filteredColumnData = [];
				for ( let i = 0; i < columnData.length; i++ ) {
					let val = columnData[ i ];
					if ( val && val.indexOf( '<' ) === 0 ) {
						filterTextTesting.innerHTML = val;
						val = filterTextTesting.innerText;
					}
					if (
						! ( filteredColumnData.indexOf( val ) >= 0 )
					) {
						filteredColumnData.push( val );
					}
				}
				filteredColumnData = filteredColumnData.sort(
					function ( a, b ) {
						return new Date( b ) - new Date( a );
					}
				);

				filterField += `<option value="">${filterName}</option>`;

				let optionsArray = []

				filteredColumnData.forEach( ( val ) => {
					if (isSplit) {
						val.split(', ').forEach(v => {
							optionsArray.push(v);
						})
					} else {
						optionsArray.push(val);
					}
				} );

				optionsArray = optionsArray.filter((value, index, array) => value !== '' && array.indexOf(value) === index)

				optionsArray.forEach( ( val ) => {
					filterField += `<option value="${ val }">${ val }</option>`;
				} );

				filterField += '</select></div>';

			} else if ( filterableColumns[ colIndex ] === 'date' ) {

				let heading = tableHeadings[colIndex];
				let filter_key = heading.dataset.key;
				tableOptions.dateFilterKey = filter_key && filter_key !== '' ? filter_key : colIndex;

				if ( heading.dataset.subtype ) {
					if( heading.dataset.subtype === 'start' ) {
						filterField = `<div class="dt-filter-wrapper"><label for="date-min-${ colIndex }">${wp.i18n.__('Start', 'levcharity')} ${ filterName }</label><input class='dt-filter' name="min" id="date-min-${ colIndex }" type='date' data-key="${ colIndex }"/></label></div>`;
					} else if( heading.dataset.subtype === 'end' ) {
						filterField = `<div class="dt-filter-wrapper"><label for="date-max-${ colIndex }">${wp.i18n.__('End', 'levcharity')} ${ filterName }</label><input class='dt-filter' name="max" id="date-max-${ colIndex }" type='date' data-key="${ colIndex }"/></label></div>`;
					}
				} else {
					filterField = `<div class="dt-filter-wrapper"><label for="date-min-${ colIndex }">${wp.i18n.__('Start', 'levcharity')} ${ filterName }</label><input class='dt-filter' name="min" id="date-min-${ colIndex }" type='date' data-key="${ colIndex }"/></label></div>`;
					filterField += `<div class="dt-filter-wrapper"><label for="date-max-${ colIndex }">${wp.i18n.__('End', 'levcharity')} ${ filterName }</label><input class='dt-filter' name="max" id="date-max-${ colIndex }" type='date' data-key="${ colIndex }"/></label></div>`;
				}
			} else {
				filterField = `<div class="dt-filter-wrapper"><input placeholder="${filterName}" id="${ filterName }-${ colIndex }" class='dt-filter' type='text' data-key="${ colIndex }"/></div>`;
			}
			if(appendTheFilter) {
				filtersWrapper.innerHTML += `<div class="dt-filter-wrapper filter-type-${ filterableColumns[ colIndex ] }" data-key="${ colIndex }">${ filterField }</div>`;
			}
			if(rangepickerElement) {
				setTimeout(() => {
					new Lightpick({
						field: document.getElementById(`daterange-${rangepickerElement}`),
						singleDate: false,
						selectForward: true,
						onSelect: function(start, end){
							let dateFilterStart = start ? start.format('YYYY-MM-DD') : '',
								dateFilterEnd = end ? end.format('YYYY-MM-DD') : '';

							if(dateFilterEnd && dateFilterStart && dateFilterStart <= dateFilterEnd) {
								dateFilterEnd = new Date(dateFilterEnd);
								dateFilterStart = new Date(dateFilterStart);
								levDatatable
									.column( index )
									.search(function (value, index, array) {
										var date = new Date(value);
										return date >= dateFilterStart && date <= dateFilterEnd;
									})
									.draw();
							}

						}
					});
				}, 500);
			}
		} );
	}


	_updateChoices() {
		if(this._choices.length) {
			for (const choice of this._choices) {
				const choices = [];
				const options = choice?.passedElement?.element?.options || [];

				options.forEach((option) => {
					choices.push({
						value: option.value,
						label: option.value,
					})
				});
				choice.setChoices(choices)
			}
		}
	}

	async initChoices() {
		const selector = '.multi_choices.datatable_multiselect';
		const selects = document.querySelectorAll(selector)
		if(selects.length) {
			await import('../../../node_modules/choices.js/public/assets/scripts/choices.min.js');
			let i = 0;
			for (const select of selects) {
				const choice = new Choices(select, {
					shouldSortItems: false,
					removeItemButton: true,
					classNames: {
						containerOuter: 'choices' + (selects.length === 1 ? ' primary' : ''),
					}
				});

				const index = +select?.dataset?.key || 0;

				this._choices[index] = choice;
				i++;
			}
		}

	}

	_getChoiceValues(index) {
		let searchValues = [],
			choicesList = this._choices[index].itemList.element,
			currentChoices = choicesList?.children || [];

		if(currentChoices.length) {
			currentChoices.forEach((choice) => {
				if (choice.dataset?.value) {
					searchValues.push(`^${choice.dataset.value}$`);
				}
			});
		}
		if(this.#dataTables){
			choicesList.closest('.lev-datatable--actions').style.paddingBottom = choicesList.offsetHeight + 8 + 'px';
			const choicesField = choicesList.closest('.choices');

			if (choicesField.classList && !choicesField.classList.contains('is-flipped')){
				choicesField.top = choicesField.offsetHeight + 'px';
			}
		}

		return searchValues.length ? searchValues.join('|') : ''
	}

	_addEvents(levDatatable) {
		const that = this;
		document
			.addEventListener( 'change', ( e ) => {
				if(!e.target.matches('.dt-filter')) return;

				const filter = e.target;

				const index = filter.dataset.key;

				const isSplit = filter?.dataset?.splitDropdown === 'true'

				const isMultiple = filter.getAttribute('multiple');
				if (isMultiple && isMultiple === 'multiple') {
					let searchValues = that._getChoiceValues(index);

					document.body.click();

					levDatatable
						.column( index )
						.search( searchValues, true, false )
						.draw();
				} else if ( filter.getAttribute( 'type' ) === 'date' ) {
					levDatatable.draw();
				} else if (
					levDatatable.column( index ).search() !==
					e.target.value
				) {
					let searchValue = e.target.value;

					if(filter.getAttribute("data-content")  !== "html"){
						if (isSplit) {
							searchValue = searchValue || '';
							levDatatable
								.column(index)
								.search(searchValue, true, false)
								.draw();
						} else {
							searchValue = searchValue ? '^' + searchValue + '$' : '';
							levDatatable
								.column(index)
								.search(searchValue, true, false)
								.draw();
						}
					}
					else if( filter.getAttribute("data-defaultfilter") !== "" ){
						let filterValue = filter.getAttribute("data-filterdefault");
						let select = document.querySelector("#Status-7");
						if(select && select.value == ""){
							levDatatable.column(7).search(`^(?!.*${filterValue}).*$`, true, false).draw();
						}else{
							levDatatable
								.column( index )
								.search( searchValue, true, false )
								.draw();
						}
					}
					else{
						levDatatable
							.column( index )
							.search( searchValue, true, false )
							.draw();
					}
				}
			} );
		document
			.addEventListener( 'keyup', ( e ) => {
				if (!e.target.matches('.dt-filter')) return;

				const filter = e.target;
				if ( filter.getAttribute( 'type' ) !== 'date' ) {
					const index = filter.dataset.key;
					if (
						levDatatable
							.column( index )
							.search() !== e.target.value
					) {
						levDatatable
							.column( index )
							.search( e.target.value )
							.draw();
					}
				}
			});
	}

	_datatableActions() {
		document.addEventListener('change', async (event) => {
			if (event.target.matches('.select_actions_wrapper')) {
				if (event.target.selectedOptions[0].dataset.url) {
					if (event.target.selectedOptions[0].dataset.newtab === 'true') {
						window.open(event.target.selectedOptions[0].dataset.url, '_blank')
						event.target.value = '';
					} else {
						window.location.href = event.target.selectedOptions[0].dataset.url;
					}
				}
			}
		});
	}

	addExistingFilters(table, levDatatable) {
		if(table && levDatatable) {
			let table_id = table.getAttribute('id');

			let existingFiltersElements = document.querySelectorAll(`[data-for="${table_id}"]`);

			if(existingFiltersElements){
				Array.from(existingFiltersElements).forEach((element)=>{
					let elementTagName = element.tagName.toLowerCase();
					if(elementTagName === 'select') {
						element.addEventListener('change', (event)=>{
							let name = event.target.getAttribute('name');
							let data_table = levDatatable;
							let settings = data_table.settings()[0];
							let ajax = settings.ajax;

							ajax.data[name] = event.target.value;
							if(event.target.value === ''){
								levDatatable.ajax.reload();
							}
						})
					}
					if(elementTagName === "input"){
						element.addEventListener('input', (event)=>{
							let name = event.target.getAttribute('name');
							let data_table = levDatatable;
							let settings = data_table.settings()[0];
							let ajax = settings.ajax;
							ajax.data[name] = event.target.value;

							if(event.target.value === ''){
								levDatatable.ajax.reload();
							}
						})
					}
				})
			}
		}
	}

	#renderChildRow(data) {
		data = data?.child_row || [];

		let content = ''
		const columns = [];
		let headings = [];

		if (Array.isArray(data)){
			headings = Object.keys(data[0]);

			for (const i in data) {
				for (const j in Object.values(data[i])) {
					const item = Object.values(data[i])[j];
					if (typeof columns[j] !== 'undefined'){
						columns[j].push(item)
					} else {
						columns.push([item])
					}
				}
			}
		}

		for (const i in columns){
			let column = columns[i].map(cell => `<span class="cell">${cell}</span>`)

			if (typeof headings[i] !== 'undefined'){
				column = [`<span class="cell heading">${headings[i]}</span>`, ...column];
			}

			content += `<div class="column">${column.join('')}</div>`;
		}

		return `<div class="levcharity_datatable_child_row">${content}</div>`;
	}
}
